var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('subsidiary-table',{attrs:{"api-u-r-l":_vm.apiURL,"title":_vm.title,"module":"subsidiary"}})}
var staticRenderFns = []

export { render, staticRenderFns }